export default "__VITE_ASSET__BXSrYXfC__"